export default __webpack_public_path__ + "static/media/three.fc761dcb.svg";